import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Image,
  InputGroup,
  InputRightElement,
  Text,
  useDisclosure,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Step,
  StepIcon,
  StepIndicator,
  StepNumber,
  Stepper,
  StepSeparator,
  StepStatus,
  StepTitle,
  Table,
  TableContainer,
  Tbody,
  Td,
  Thead,
  Tr,
  // useDisclosure,
} from "@chakra-ui/react";
import TableLocking from "./tableLocking";
import IconFile from "../../assets/images/booking/upfile.svg";
import iconPlus from "../../assets/images/booking/plus.svg";
import PopupImport from "../../components/popup/PopupImport";
// import FormDetail from "./form/detail";
import { commonCall } from "../../api/common";
import toast from "react-hot-toast";
import { lockingCall } from "../../api/locking";
import { lockingImageCall } from "../../api/lockingImage";
import { lockingParticipantCall } from "../../api/lockingParticipant";
import { exportFile, formatDateDb, formatDateHourDb } from "../../utils/tools";
import { formatDateToLocal, formatPriceUS } from "../../utils/utils";
import { useLocking } from "../../hooks/useLooking";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { lockingRelativeParticipantCall } from "../../api/lockingRelativeParticipant";
import { formatTableValue } from "./formatTable";
import iconApproved from "../../assets/images/receiveSalary/check-circle.svg";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { InputControl } from "../../components/form/formControls";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import DatePicker from "react-datepicker";
import { ConfirmCommissionStatus, ConfirmInformationStatus } from "./constants";

const schemaEdit = Yup.object().shape({
  priceForCommission: Yup.string().required("Số tiền phí dịch vụ là bắt buộc"),
  bookingTime: Yup.string().required("Vui lòng nhập thời điểm tính"),
});

export default function ServiceFeeManagementStep2Detail({
  lockingId,
  locking,
  setLocking,
  getLocking,
  handleNext,
  handlePrevious,
}) {
  const {
    register,
    setValue,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schemaEdit),
    defaultValues:
      {
        ...locking,
        priceForCommission:
          locking?.priceForCommission ||
          locking?.apartment?.priceForCommission ||
          locking?.apartment?.estimatedServiceFeePrice ||
          0,
        bookingTime: locking?.transactionDate || locking?.bookingTime,
      } || {},
  });

  const [zIndex, setZIndex] = useState("");
  const [focusStates, setFocusStates] = useState({});
  const [lockingRelativeParticipant, setRelativeParticipant] = useState([]);

  const [relativeLocking, setRelativeLocking] = useState([]);

  const handleFocus = (field, data) => {
    if (data) {
      setZIndex(data);
    }
    setFocusStates((prev) => ({ ...prev, [field]: true }));
  };

  const handleBlur = (field, data) => {
    setZIndex("");
    setFocusStates((prev) => ({ ...prev, [field]: false }));
  };

  const handleDateChange = (selectedDate, inputName) => {
    setValue(inputName, selectedDate, { shouldValidate: true });
  };

  const [displayPrice, setDisplayPrice] = useState(0);
  const onChangePrice = useCallback(
    (event) => {
      const { value } = event.target;
      const numericValue = value.replace(/[^0-9]/g, "");
      setDisplayPrice(formatPriceUS(numericValue));
      setValue("priceForCommission", Number(numericValue), {
        shouldValidate: true,
      });
    },
    [setValue, watch, formatPriceUS],
  );

  const submit = (data) => {
    // console.log("data", data);

    const dataEdit = {
      confirmInformationStatus: ConfirmInformationStatus.APPROVED,
    };

    const lockingRelativeParticipantData = relativeLocking.map((item) => ({
      employeeId: item?.employeeId,
      workingDays: item?.workingDays || 0,
      isBrokerDebtCertificate: item?.isBrokerDebtCertificate || false,
      amountHeld: item?.amountHeld || 0,
    }));

    if (lockingRelativeParticipantData?.length > 0) {
      dataEdit.dataRelativeParticipant = lockingRelativeParticipantData;
    }

    if (data?.priceForCommission) {
      dataEdit.priceForCommission = data?.priceForCommission;
    }

    if (data?.bookingTime) {
      dataEdit.bookingTime = data?.bookingTime;
    }

    approveInformation(lockingId, dataEdit);
  };

  const submitHandler = (data) => {
    submit(data);
  };

  const getRelativeLocking = async (lockingId) => {
    const participants =
      await lockingRelativeParticipantCall.getAttendanceManager(lockingId);

    if (participants?.items) {
      let mappedData = null;
      if (participants?.items) {
        mappedData = participants?.items.map((item) => ({
          employeeId: item?.employeeId || "",
          code: item?.code || "",
          fullName: item?.fullName || "",
          interpretation: item?.interpretation || "",
          fullNameRelative: item?.fullNameRelative || "",
          workingDays: item?.workingDays || "0",
          isBrokerDebtCertificate: item?.isBrokerDebtCertificate || false,
          amountHeld: item?.amountHeld || "0",
          status: false,
        }));
      }
      setRelativeLocking(mappedData);
    }
  };

  const getLockingRelativeParticipant = async (lockingId) => {
    const participants =
      await lockingRelativeParticipantCall.getGroupRelativeParticipantsByLockingId(
        lockingId,
      );

    if (participants) {
      setRelativeParticipant(participants);
    }
  };

  useEffect(() => {
    if (lockingId) {
      getLockingRelativeParticipant(lockingId);
      getRelativeLocking(lockingId);
    }

    if (locking) {
      setDisplayPrice(
        formatPriceUS(
          locking?.priceForCommission ||
            locking?.apartment?.priceForCommission ||
            locking?.apartment?.estimatedServiceFeePrice ||
            0,
        ),
      );
    }
  }, [lockingId]);

  const approveLockingRelative = async (
    lockingId,
    status = ConfirmCommissionStatus.APPROVED,
  ) => {
    const toastCreate = toast.loading("Đang cập nhật trạng thái ...");
    const dataFormat = {
      registerRelativeStatus: status,
    };
    try {
      const data = await lockingCall.approveRegisterRelative(
        lockingId,
        dataFormat,
      );
      if (data) {
        handleNext();
        await getLocking(lockingId);
        toast.success("Cập nhật trạng thái thành công");
      }
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const approveInformation = async (lockingId, formatData) => {
    const toastCreate = toast.loading("Đang cập nhật trạng thái ...");

    try {
      const data = await lockingCall.approveInformation(lockingId, formatData);
      if (data) {
        handleNext();
        await getLocking(lockingId);
        toast.success("Cập nhật trạng thái thành công");
      }
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  return (
    <Box>
      <Box m={"24px 0"} w={"100%"}>
        <Text
          color={"var(--color-header-employee)"}
          fontSize={"16px"}
          fontWeight={"600"}
        >
          Nhân viên tham gia
        </Text>
        <Box
          background={"var(--fill-avatar)"}
          mt={"16px"}
          p={4}
          borderRadius={"8px"}
        >
          {lockingRelativeParticipant?.map((item, index) => (
            <Box mb={3} key={index}>
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
              >
                {item?.member?.employee?.fullName || "-"}:{" "}
                {item?.member?.commissionRate + "%" || "0 %"}
              </Text>
              <Box mt={2}>
                <Text
                  color={"var(--color-header-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                >
                  {"Người bán chính"}{" "}
                  {`(${item?.member?.employee?.fullName || "-"})`}:{" "}
                  {((item?.member?.commissionRate || 0) *
                    (item?.member?.relativeCommissionRate || 0)) /
                    100 +
                    "%" || "0 %"}
                </Text>

                {item?.relatives &&
                  item?.relatives?.length > 0 &&
                  item?.relatives?.map((relative, index) => (
                    <Box key={index}>
                      <Text
                        color={"var(--color-header-employee)"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                      >
                        {"CTV"} {`(${relative?.employee?.fullName || "-"})`}:{" "}
                        {((relative?.commissionRate || 0) *
                          (relative?.relativeCommissionRate || 0)) /
                          100 +
                          "%" || "0 %"}
                      </Text>
                    </Box>
                  ))}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>

      <Box w={"100%"}>
        <form onSubmit={handleSubmit(submitHandler)}>
          <Box w={"100%"} mt={"20px"}>
            <Flex justifyContent={"space-between"} mb={"16px"}>
              <Text
                fontSize={"16px"}
                lineHeight={"19px"}
                fontWeight={"600"}
                color={"var(--color-header-employee)"}
              >
                Thông tin chung
              </Text>
              {locking?.confirmInformationStatus ===
                ConfirmInformationStatus.APPROVED && (
                <Flex gap={"8px"}>
                  <Text
                    color={"var(--color-header-employee)"}
                    fontSize={"16px"}
                    lineHeight={"19px"}
                    fontWeight={"600"}
                  >
                    Thời gian duyệt:
                  </Text>
                  <Text
                    color={"var(--color-header-employee)"}
                    fontSize={"16px"}
                    lineHeight={"19px"}
                    fontWeight={"600"}
                  >
                    {locking?.confirmInformationApprovedAt
                      ? formatDateHourDb(locking.confirmInformationApprovedAt)
                      : "-"}
                  </Text>
                </Flex>
              )}
            </Flex>
            {/* 2 */}
            <Flex
              justifyContent={"space-between"}
              alignItems={"flex-start"}
              gap={"27px"}
              mb={"12px"}
              w={"100%"}
            >
              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Dự án
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {locking?.project?.name || ""}
                </Text>
              </Box>
              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Sản phẩm
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {`${locking?.apartment?.code || ""} ${
                    locking?.apartment ? `(${locking?.apartment?.name})` : ""
                  }`}
                </Text>
              </Box>
            </Flex>
            {/* 3 */}
            <Flex
              justifyContent={"space-between"}
              alignItems={"flex-start"}
              gap={"27px"}
              mb={"12px"}
              w={"100%"}
            >
              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Người tạo
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {locking?.booker?.fullName || ""}
                </Text>
              </Box>
              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Ngày tạo
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {formatDateDb(locking?.createdAt || "")}
                </Text>
              </Box>
            </Flex>
            {/* 4 */}
            {/* 5 */}
            <Flex
              justifyContent={"space-between"}
              alignItems={"flex-start"}
              gap={"27px"}
              mb={"12px"}
              w={"100%"}
            >
              <Box flex={1}>
                <InputControl
                  // type="number"
                  label="Giá tính phí dịch vụ"
                  placeholder="Nhập phí dịch vụ"
                  errors={errors.priceForCommission}
                  register={register("priceForCommission")}
                  onFocus={() => handleFocus("priceForCommission")}
                  onBlur={() => handleBlur("priceForCommission")}
                  onChange={onChangePrice}
                  value={displayPrice}
                  state={focusStates["priceForCommission"]}
                  disabled={
                    locking?.confirmInformationStatus ===
                    ConfirmInformationStatus.APPROVED
                  }
                />
                <Text
                  fontSize={{ base: "12px" }}
                  color={"var(--color-option-employee-hover)"}
                  mt={"4px"}
                >
                  (
                  {locking?.priceForCommission ||
                  locking?.apartment?.priceForCommission
                    ? "Lấy theo giá tính phí dịch vụ"
                    : "Lấy theo giá tạm tính"}
                  )
                </Text>
              </Box>

              <FormControl flex={1} zIndex={zIndex === "bookingTime" ? 3 : 0}>
                <FormLabel
                  mb={"6px"}
                  fontSize={{ base: "12px" }}
                  fontWeight={400}
                  color={
                    focusStates["bookingTime"]
                      ? "var(--color-option-employee-hover)"
                      : "var(--color-label-employee)"
                  }
                >
                  Ngày khách hàng chuyển tiền / ngày cọc
                </FormLabel>
                <InputGroup>
                  <DatePicker
                    width="100%"
                    selected={watch("bookingTime")}
                    onChange={(date) => handleDateChange(date, "bookingTime")}
                    dateFormat="dd/MM/yyyy"
                    locale="vi"
                    placeholderText="dd/mm/yy"
                    className="custom-datepicker datePickerStyle"
                    onFocus={() => handleFocus("bookingTime", "bookingTime")}
                    onBlur={() => handleBlur("bookingTime")}
                    disabled={
                      locking?.confirmInformationStatus ===
                      ConfirmCommissionStatus.APPROVED
                    }
                  />
                  <InputRightElement pointerEvents="none" h={"44px"}>
                    <Image src={calendarIcon} />
                  </InputRightElement>
                </InputGroup>
                {errors.bookingTime && (
                  <Text fontSize={{ base: "12px" }} color={"red"}>
                    {errors.bookingTime.message}
                  </Text>
                )}
              </FormControl>
            </Flex>
          </Box>
          {locking?.confirmInformationStatus !==
          ConfirmInformationStatus.APPROVED ? (
            <Box display="flex" justifyContent="flex-end" p={"24px 0"}>
              <Button
                type="submit"
                p={"13px 45px"}
                lineHeight={"18px"}
                fontSize={"15px"}
                fontWeight={600}
                color={"var(--color-main)"}
                borderRadius={"8px"}
                bg={"var(--color-option-employee-hover)"}
                _hover={{
                  filter: "brightness(90%)",
                }}
              >
                Duyệt
              </Button>
            </Box>
          ) : (
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              gap={"16px"}
              p={"24px 0"}
            >
              <Button
                type="submit"
                p={"13px 45px"}
                lineHeight={"18px"}
                fontSize={"15px"}
                fontWeight={600}
                color={"var(--color-main)"}
                borderRadius={"8px"}
                bg={"var(--color-option-employee-hover)"}
                _hover={{
                  filter: "brightness(90%)",
                }}
              >
                Duyệt lại
              </Button>
              <Flex
                w={"max-content"}
                alignItems={"center"}
                justifyContent={"center"}
                gap={1}
              >
                <Image src={iconApproved} w={"20px"} />
                <Text color={"var(--color-status-employ)"}>Đã được duyệt</Text>
              </Flex>
            </Box>
          )}
        </form>
      </Box>
    </Box>
  );
}
